import type { RootState } from '@/app/store';
import type { User, UserValidation } from '../types/session.types';
import type { Roles } from '@/app/enums';

export const selectSessionLoading = (state: RootState): boolean =>
  state.session.loading;

export const selectSessionUser = (state: RootState): User | null =>
  state.session.user;

export const selectIsAppInitialised = (state: RootState): boolean =>
  state.session.appInitialised;

export const selectUserAccessProfile = (
  state: RootState
): UserValidation | null => state.session.userAccessProfile;

export const selectUserRole = (state: RootState): Roles => state.session.role;

export const selectUserRejected = (state: RootState): boolean =>
  state.session.userRejected;
